import { Button, Space } from "antd";
import { FormMode, modalSubmitLabel } from "./InModal.default";

export interface ModalFooterProps {
  readonly mode: FormMode;
  readonly loading?: boolean;
  // When false the primary action is disabled (except for delete). Omit (or true) to keep it enabled.
  readonly valid?: boolean;
  readonly onCancel?: () => void;
  readonly onSubmit?: () => void;
  readonly submitText?: string;
  readonly cancelText?: string;
}

// The standard Cancel + primary-action modal footer. Centralizes button order, the delete danger styling, the
// loading/disabled wiring, and the submit label.
function ModalFooter(props: ModalFooterProps) {
  const isDelete = props.mode === "delete";
  return (
    <Space>
      <Button disabled={props.loading} onClick={props.onCancel}>
        {props.cancelText ?? "Cancel"}
      </Button>
      <Button
        type="primary"
        danger={isDelete}
        loading={props.loading}
        disabled={!(props.valid ?? true) && !isDelete}
        onClick={props.onSubmit}
      >
        {props.submitText ?? modalSubmitLabel(props.mode)}
      </Button>
    </Space>
  );
}

export default ModalFooter;
